import { render, staticRenderFns } from "./supply-model-buy.vue?vue&type=template&id=5b5f5b08&scoped=true"
import script from "./supply-model-buy.vue?vue&type=script&lang=ts"
export * from "./supply-model-buy.vue?vue&type=script&lang=ts"
import style0 from "./supply-model-buy.vue?vue&type=style&index=0&id=5b5f5b08&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b5f5b08",
  null
  
)

export default component.exports